/*
 * O menu da sessão abre com quem está logado: avatar, nome e
 * @usuário, que levam ao perfil. No Flarum o menu começa direto em "Perfil";
 * aqui ele ganha esse cabeçalho, e o resto dos itens (de outras extensões
 * também) segue igual.
 */
import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import SessionDropdown from 'flarum/forum/components/SessionDropdown';
import Avatar from 'flarum/common/components/Avatar';
import Link from 'flarum/common/components/Link';
import Separator from 'flarum/common/components/Separator';
export default function installSessionMenu() {
  extend(SessionDropdown.prototype, 'items', function (items) {
    const user = app.session.user;
    if (!user) return;
    const displayName = user.displayName();
    const username = user.username();
    items.add('canelaIdentity', m(Link, {
      className: "CanelaSessionIdentity",
      href: app.route.user(user)
    }, m(Avatar, {
      user: user,
      className: "CanelaSessionIdentity-avatar"
    }), m("span", {
      className: "CanelaSessionIdentity-names"
    }, m("span", {
      className: "CanelaSessionIdentity-name"
    }, displayName), displayName !== username && m("span", {
      className: "CanelaSessionIdentity-username"
    }, "@", username))), 200);
    items.add('canelaIdentitySeparator', m(Separator, null), 150);
  });
}
flarum.reg.add('ramon-canela', 'forum/user/installSessionMenu', installSessionMenu);